module.exports = __webpack_public_path__ + "static/media/warning.bb42c1e1.svg";